import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';

import { IReportEmbedConfiguration } from 'powerbi-client';
import { MenuItem } from 'primeng/api';
import { PowerBiWidgetConfiguration } from '../../../models/powerbi-widget.model';
import {
  WidgetComponent,
  WidgetConfigurationType,
} from '../../../models/widget-configuration.model';
import { PowerBiWidgetConfigurationComponent } from '../powerbi-widget-configuration/powerbi-widget-configuration.component';
import { PowerbiService } from './powerbi.service';

@Component({
  selector: 'carehub-powerbi-widget',
  imports: [
    ButtonModule,
    InputNumberModule,
    InputTextModule,
    FormsModule,
    MenuModule,
    ReactiveFormsModule,
    PowerBIEmbedModule,
    PowerBiWidgetConfigurationComponent
],
  templateUrl: './powerbi-widget.component.html',
  styleUrl: './powerbi-widget.component.scss',
})
export class PowerBiWidgetComponent implements OnInit, WidgetComponent {
  @ViewChild('configurationComponent')
  configurationComponent!: PowerBiWidgetConfigurationComponent;

  @Input() isEditing: boolean = false;
  @Input() configuration: PowerBiWidgetConfiguration | undefined;

  @Input() configurationChange: EventEmitter<WidgetConfigurationType> =
    new EventEmitter<WidgetConfigurationType>();

  @Input() configurationDelete: EventEmitter<WidgetConfigurationType> =
    new EventEmitter<WidgetConfigurationType>();

  @Input() loadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  powerbiConfig: IReportEmbedConfiguration | undefined;

  actionMenuItems: MenuItem[] = [
    {
      label: $localize`:@@common.button.edit:Edit`,
      command: () => this.onEdit(),
    },
    {
      label: $localize`:@@common.button.delete:Delete`,
      command: () => this.onDelete(),
    },
  ];

  constructor(
    private powerbiService: PowerbiService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadPowerBiConfig();
  }

  get powerBiConfig(): PowerBiWidgetConfiguration | undefined {
    return this.configuration as PowerBiWidgetConfiguration;
  }

  onEdit(): void {
    this.isEditing = true;
    this.changeDetector.detectChanges();
  }

  onConfigurationUpdate(): void {
    if (this.configurationComponent && this.configurationComponent.isValid()) {
      const newConfiguration: WidgetConfigurationType =
        this.configurationComponent.getConfiguration();

      this.isEditing = false;

      const newPowerBiConfig: PowerBiWidgetConfiguration =
        newConfiguration as PowerBiWidgetConfiguration;
      if (newPowerBiConfig.url !== this.powerBiConfig?.url) {
        this.loadPowerBiConfig();
      }

      this.configurationChange.emit(newConfiguration);
    }
  }

  onConfigurationCancel(): void {
    this.isEditing = false;
  }

  isConfigurationValid(): boolean {
    return this.configurationComponent?.isValid() || false;
  }

  onDelete(): void {
    this.configurationDelete.emit(this.configuration);
  }

  onPowerBiConfigChange(config: IReportEmbedConfiguration): void {
    this.powerbiConfig = config;
  }

  private loadPowerBiConfig(): void {
    if (this.configuration?.url) {
      this.loadingChange.emit(true);
      this.powerbiService.getPowerBiEmbed(this.configuration.url).subscribe({
        next: (config) => {
          this.powerbiConfig = config;
          this.loadingChange.emit(false);
        },
        error: () => {
          this.loadingChange.emit(false);
        },
      });
    }
  }
}
